import React from 'react';

import { Switch } from 'react-router-dom';
import Route from './Route';

import SignIn from '~/pages/SignIn';
import Pharmacy from '~/pages/Pharmacy';
import Patients from '~/pages/Patients';
import Maps from '~/pages/Maps';
import Reports from '~/pages/Reports';

export default function Routes() {
  return (
    <Switch>
      <Route path="/" exact component={SignIn} />

      <Route path="/search" component={Patients} isPrivate />
      <Route path="/drug" component={Pharmacy} isPrivate />

      {/* Map report pages */}
      <Route path="/maps" exact component={Maps} isPrivate />
      <Route path="/maps/patients" component={Maps} isPrivate />
      <Route path="/maps/bloods" component={Maps} isPrivate />
      <Route path="/maps/infusions" component={Maps} isPrivate />
      <Route path="/maps/emergencies" component={Maps} isPrivate />

      {/* Excel report pages */}
      <Route path="/reports" exact component={Reports} isPrivate />
      <Route path="/reports/pharmacy" component={Reports} isPrivate />
      <Route path="/reports/patients" component={Reports} isPrivate />
      <Route path="/reports/bloods" component={Reports} isPrivate />
      <Route path="/reports/infusions" component={Reports} isPrivate />
      <Route path="/reports/emergencies" component={Reports} isPrivate />
    </Switch>
  );
}
